import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useEffect, useState, useRef } from "react";
import { toasterWarning } from "../../Components/toaster";
import notificationsService from "../../services/notificationsService";
dayjs.extend(duration);

export const ticketsData = [
  { id: "TCK-1024", title: "Requesting for new PC", date: "Oct 28, 2025" },
  { id: "TCK-1025", title: "Requesting for new PC", date: "Oct 28, 2025" },
  { id: "TCK-1026", title: "Requesting for new PC", date: "Oct 28, 2025" },
];

export const ticketTabs = [
  { label: "All Tickets", count: 10 },
  { label: "In Progress", count: 6 },
  { label: "Completed", count: 2 },
];

export const birthdays = [
  { date: "18th Sept 2025 (Thursday)", name: "Rohit Kumar", team: "Sales" },
  { date: "22nd Sept 2025 (Monday)", name: "Priya Mehta", team: "Design" },
  { date: "22nd Sept 2025 (Monday)", name: "Rahul", team: "Design" },
  { date: "22nd Sept 2025 (Monday)", name: "Mamatha", team: "Design" },
  { date: "22nd Sept 2025 (Monday)", name: "Priya", team: "Design" },
  { date: "25th Dec 2025 (Thursday)", name: "Anil Verma", team: "Finance" },
];

export const attendanceData = {
  shift: "9:00 AM – 6:00 PM",
  loggedHours: "04:32:56",
  location: "Madhapur, xyz",
};

export const attendanceActions = {
  buttonText: "Check Out",
};

export const holidays = [
  { date: "2nd Oct 2025 (Thursday)", name: "Gandhi Jayanti" },
  { date: "11th Oct 2025 (Saturday)", name: "Dussehra" },
  { date: "1st Nov 2025 (Saturday)", name: "Diwali" },
  { date: "1st Nov 2025 (Saturday)", name: "Diwali" },
];

export const payslipData = [
  {
    month: "October",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Nov 2025",
  },
  {
    month: "September",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Oct 2025",
  },
  {
    month: "August",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Sep 2025",
  },
  {
    month: "July",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Aug 2025",
  },
  {
    month: "June",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Jul 2025",
  },
  {
    month: "May",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Jun 2025",
  },
  {
    month: "April",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 May 2025",
  },
  {
    month: "March",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Apr 2025",
  },
  {
    month: "February",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Mar 2025",
  },
  {
    month: "January",
    year: 2025,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Feb 2025",
  },
  {
    month: "December",
    year: 2024,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Jan 2024",
  },
  {
    month: "November",
    year: 2024,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Dec 2024",
  },
  {
    month: "October",
    year: 2024,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Nov 2024",
  },
  {
    month: "September",
    year: 2024,
    grossSalary: "₹50,000",
    netSalary: "₹45,000",
    creditedOn: "1 Oct 2024",
  },
];

export const sortOptions1 = [
  { key: "date", label: "Date" },
  { key: "working_duration", label: "Work Duration" },
  { key: "break_info", label: "Break Duration" },
  { key: "first_check_in", label: "Check In" },
  { key: "last_check_out", label: "Check Out" },
];
export const sortPayslips = [
  { key: "month", label: "Month" },
  { key: "year", label: "Year" },
  { key: "credited_on", label: "Credited On" },
];
export const sortHelpDesk = [
  { key: "ticketId", label: "Ticket ID" },
  // { key: "year", label: "Year" },
  { key: "createdat", label: "Created At" },
];
export const priorityHelpDesk = [
  { key: "", label: "All", },
  { key: "low", label: "Low" },
  { key: "medium", label: "Medium" },
  { key: "high", label: "High" },
];
export const sortApprovals = [
  { key: "request_id", label: "Request ID" },
  // { key: "dates", label: "Date" },
  { key: "category", label: "Category" },
];
export const sortApprovalsStatus = [
  { key: "pending", label: "Pending" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
];
export const FilterHelpDesk = [
  { key: "", label: "All" },
  { key: "open", label: "Open" },
  { key: "Closed", label: "Closed" },
];

export const sortEngage = [
  { key: "newest", label: "Newest" },
  { key: "oldest", label: "Oldest" },
];


export const getWorkingDuration = (checkIn) => {
  if (!checkIn) return "0";

  const start = dayjs(checkIn);
  const now = dayjs();

  const diffMs = now.diff(start);
  const dur = dayjs.duration(diffMs);

  const hours = Math.floor(dur.asHours());
  const minutes = dur.minutes();
  const seconds = dur.seconds();

  const h = String(hours).padStart(2, "0");
  const m = String(minutes).padStart(2, "0");
  const s = String(seconds).padStart(2, "0");

  return `${h}h ${m}m ${s}s`;
};

export const getCheckInReminderMessage = (checkIn) => {
  const now = dayjs();
  const reminderTime = dayjs().hour(9).minute(5).second(0);

  if (!checkIn && now.isAfter(reminderTime)) {
    return "You have not checked in yet. Please check in.";
  }

  return null;
};

export const shouldShowCheckInPopup = (checkIn) => {
  const now = dayjs();

  const loginStart = dayjs().hour(9).minute(5).second(0);
  const loginEnd = dayjs().hour(18).minute(0).second(0);

  const isWithinOfficeHours = now.isAfter(loginStart) && now.isBefore(loginEnd);
  if (!checkIn && isWithinOfficeHours) {
    return true;
  }

  return false;
};

export const mergeParamsIntoUrl = (url, params) => {
  if (!url) return url;
  try {
    const base = process.env.REACT_APP_API_BASE_URL || window.location.origin;
    const u = new URL(url, base);
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v !== "" && v !== null && v !== undefined)
        u.searchParams.set(k, String(v));
    });
    return u.toString();
  } catch (e) {
    return url;
  }
};

export const useLiveTimer = (checkInTime, checkOutTime) => {
  const [time, setTime] = useState("00:00:00");
  const hasNotifiedRef = useRef(false);

  // stopUpdatesRef ensures we stop the interval after 11:30pm
  const stopUpdatesRef = useRef(false);

  useEffect(() => {
    let timerId = null;

    hasNotifiedRef.current = false;
    stopUpdatesRef.current = false;

    if (!checkInTime) {
      setTime("00:00:00");
      return () => {};
    }

    if (checkOutTime) {
      setTime(getWorkingDuration(checkInTime, checkOutTime));
      return () => {};
    }

    const checkAndUpdate = () => {
      if (stopUpdatesRef.current) return;
      const now = dayjs();
      const cutoff = dayjs().hour(23).minute(30).second(0);
      // if it's past cutoff, stop updates and notify
      if (now.isAfter(cutoff) || now.isSame(cutoff)) {
        stopUpdatesRef.current = true;
        setTime(getWorkingDuration(checkInTime));

        if (!hasNotifiedRef.current) {
          hasNotifiedRef.current = true;
          const title = "Check-out reminder";
          const body = "It's past 11:30 PM — please remember to check out.";
          // try {
            // notificationsService.addNotification({ notification: { title, body }, data: { reminder: true } });
          // } catch (e) {
            // console.warn("Failed to persist checkout reminder", e);
          // }
          try {
            toasterWarning("You need to check out");
          } catch (e) {
            console.warn(e);
          }
        }

        // clear interval if set
        if (timerId) {
          clearInterval(timerId);
        }

        return;
      }

      setTime(getWorkingDuration(checkInTime));
    };

    // run immediately then every second
    checkAndUpdate();
    timerId = setInterval(checkAndUpdate, 1000);

    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, [checkInTime, checkOutTime]);

  return time;
};
